import React, { useState } from 'react';

function Step5({answers, setAnswers}) {
    
    const answerList = [
        "A. 컵의 위쪽",
        "B. 컵의 앞쪽",
        "C. 컵의 가운데",
        "D. 컵의 아래쪽",
        "E. 컵의 옆쪽",
        "F. 없음",
    ];

    const handleClick = (selectedAnswer) => {
        // "F. 없음"을 선택한 경우의 특별 처리
        if (selectedAnswer === "F. 없음") {
            if (!answers.includes("해F. 없음")) {
                setAnswers(["F. 없음"]); // 다른 모든 선택 해제
            } else {
                setAnswers([]); // 해당사항 없음 선택 해제
            }
            return;
        }

        // "F. 없음"이 이미 선택되어 있는 경우, 제거
        if (answers.includes("F. 없음")) {
            setAnswers([selectedAnswer]);
            return;
        }

        // 일반적인 다중 선택 처리
        if (answers.includes(selectedAnswer)) {
            setAnswers(answers.filter(item => item !== selectedAnswer));
        } else {
            setAnswers([...answers, selectedAnswer]);
        }
    };

    return (
        <>
            <img src="/img/bbti/question/question8.jpg" className='w-100' alt="step5" />
            {answerList?.map((data, idx) => (
                <div 
                    key={idx}
                    className={answers.includes(data) ? "answer-btn active" : "answer-btn"}
                    onClick={() => handleClick(data)}
                >
                    {data}
                </div>
            ))}
        </>
    );
}

export default Step5;